import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  ASM_SESSION_FLAG_KEY,
  HEADER_CART_ID,
  HEADER_B2B_UNIT_ID,
  HEADER_B2B_CUSTOMER_ID,
  HEADER_ASM_SESSION,
} from '@shared/tools/constants';
import { getCommerceStorageContext, getCommerceStorageKeys } from '@shared/tools/storage-keys';

/**
 * Context Headers Interceptor
 *
 * Automatically adds business context headers to all HTTP requests:
 * - X-Cart-Id: Current cart identifier
 * - X-B2B-Unit-Id: Current B2B unit identifier
 * - X-B2B-Customer-Id: Current customer identifier
 * - X-ASM-Session: ASM session flag (if active)
 *
 * Values are read directly from localStorage for optimal performance.
 * These headers are used by the backend to maintain request context.
 */
@Injectable()
export class ContextHeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, handler: HttpHandler): Observable<HttpEvent<unknown>> {
    const storageContext = getCommerceStorageContext();
    const contextKeys = getCommerceStorageKeys(storageContext);
    const cartID = localStorage.getItem(contextKeys.cartId);
    const b2bUnitID = localStorage.getItem(contextKeys.unitId);
    const b2bCustomerID = localStorage.getItem(contextKeys.customerId);

    const headers: Record<string, string> = {};

    if (cartID) headers[HEADER_CART_ID] = cartID;
    if (b2bUnitID) headers[HEADER_B2B_UNIT_ID] = b2bUnitID;
    if (b2bCustomerID) headers[HEADER_B2B_CUSTOMER_ID] = b2bCustomerID;
    if (storageContext === 'asm' && localStorage.getItem(ASM_SESSION_FLAG_KEY) === 'true') {
      headers[HEADER_ASM_SESSION] = 'true';
    }

    if (Object.keys(headers).length === 0) {
      return handler.handle(req).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
    }

    const contextReq = req.clone({
      setHeaders: headers,
    });

    return handler.handle(contextReq).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
